// removed by extract-text-webpack-plugin
module.exports = {"wrap":"style__wrap-1mJvS","userName":"style__userName-fcYLF","userNameBox":"style__userNameBox-g9xGt"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MainLayout/HeaderBar/ToolBar/style.less
// module id = 631
// module chunks = 17